import events from './Events';

const AppHooks = {
  handleAppLoaded: () => {
    events.emit('loaded');
  },

  handleSavedDrafts: ({ message, fromIdea } = {}) => {
    events.emit('saved-drafts', { message, fromIdea });
  },

  handleBackdropClicked: () => {
    events.emit('backdrop-clicked');
  },

  // after a user starts a trial, send message with updated organizationsData
  handleStartTrial: ({ message, removeScope }) => {
    events.emit('start-trial', { message, removeScope });
  },

  handleActionTaken: (message = {}) => {
    events.emit('action-taken', message);
  },
};

export default AppHooks;
